/**
 * Estado efectivo de las funcionalidades del sistema según el plan activo.
 * La llave es el `SystemFeatureCode` del backend; el valor indica si está
 * habilitada.
 */
export type SystemFeatureMap = Record<string, boolean>;

/** Códigos de feature que consume el frontend. */
export const SYSTEM_FEATURE = {
  RESTAURANT: 'RESTAURANT',
  CASH_REGISTER: 'CASH_REGISTER',
  ACCOUNTS_RECEIVABLE: 'ACCOUNTS_RECEIVABLE',
  ACCOUNTS_PAYABLE: 'ACCOUNTS_PAYABLE',
} as const;

export type SystemFeatureKey =
  (typeof SYSTEM_FEATURE)[keyof typeof SYSTEM_FEATURE];
